export default "__VITE_ASSET__07b2fa37__"